export default "assets/images/rayonnement-9913fbfc.png";